import { Color } from '@diritto/common/style/color';
import { IconProps } from '@diritto/common/style/icon';

export interface ArrowHorizontalIconProps extends IconProps {
  direction?: 'left' | 'right';
}

export const ArrowHorizontalIcon = ({ color = Color.Black, direction, size = 24 }: ArrowHorizontalIconProps) => {
  const rotate = direction === 'right' ? 180 : 0;

  return (
    <svg
      style={{ transform: `rotate(${rotate}deg)` }}
      width={(size / 24) * 16}
      height={size}
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M10.8274 5L4 12.0043L10.8274 19L12 17.7971L6.35343 12.0043L12 6.20292L10.8274 5Z" fill={color} />
    </svg>
  );
};
